// extracted by css-extract-rspack-plugin
export default {"cls1":"FullScreenPremiumModal-cls1_pn1","cls2":"FullScreenPremiumModal-cls2_8_l FullScreenPremiumModal-cls1_pn1"};